module.exports = __webpack_public_path__ + "media/images/bg/shapes/ecru/4-fde60d4cc74023616cf5ead9b9fc43ee.svg";